<template>
  <div class="results-count-wrapper">
    <p class="style-small results-count">
      Viser {{ totalFilteredItems }} af {{ totalItems }} resultater
    </p>
  </div>
</template>

<script setup>
const props = defineProps({
  totalFilteredItems: {
    type: Number,
    required: true
  },
  totalItems: {
    type: Number,
    required: true
  }
})
const emit = defineEmits(['clear-filters'])
</script>
